import {
  ResponsiveCssProp,
  SapphireCommonStyleProps,
  StyleHandlers,
} from './SapphireStyleProps';
import { FilteredProps, useSapphireStyleProps } from './useSapphireStyleProps';
import {
  sapphireTextStyleHandlers,
  SapphireTextStyleProps,
} from './useSapphireTextStyleProps';

/**
 * These are css properties related to text
 * which should be customizable only when we
 * explicitly allow it.
 *
 * https://developer.mozilla.org/en-US/docs/Learn/CSS/Styling_text/Fundamentals#other_properties_worth_looking_at
 */

export type TextStyleProps = SapphireTextStyleProps & {
  fontSize?: ResponsiveCssProp<'fontSize', 'size'>;
  fontWeight?: ResponsiveCssProp<'fontWeight', 'font'>;
  fontVariant?: ResponsiveCssProp<'fontVariant'>;
  fontKerning?: ResponsiveCssProp<'fontKerning'>;
  textTransform?: ResponsiveCssProp<'textTransform'>;
  textDecoration?: ResponsiveCssProp<'textDecoration'>;
  textShadow?: ResponsiveCssProp<'textShadow'>;
  textRendering?: ResponsiveCssProp<'textRendering'>;
  color?: ResponsiveCssProp<'color', 'color'>;
  lineHeight?: ResponsiveCssProp<'lineHeight', 'size'>;
  letterSpacing?: ResponsiveCssProp<'letterSpacing'>;
  wordSpacing?: ResponsiveCssProp<'wordSpacing'>;
};

const textStyleHandlers: StyleHandlers<TextStyleProps> = {
  ...sapphireTextStyleHandlers,
  fontSize: 'fontSize',
  fontWeight: 'fontWeight',
  fontVariant: 'fontVariant',
  fontKerning: 'fontKerning',
  textTransform: 'textTransform',
  textDecoration: 'textDecoration',
  textShadow: 'textShadow',
  textRendering: 'textRendering',
  color: 'color',
  lineHeight: 'lineHeight',
  letterSpacing: 'letterSpacing',
  wordSpacing: 'wordSpacing',
};

export const useTextStyleProps = (
  props: TextStyleProps
): {
  styleProps: {
    style: React.CSSProperties;
    className?: string;
  };
  filteredProps: FilteredProps<
    SapphireTextStyleProps,
    SapphireCommonStyleProps
  >;
} => useSapphireStyleProps<SapphireTextStyleProps>(props, textStyleHandlers);
